// extracted by mini-css-extract-plugin
export default {"root":"BottomNavigationItem_root__6KC8d","label":"BottomNavigationItem_label__Ek9IE","active":"BottomNavigationItem_active__+IM1W"};